<script>
import { mapActions } from 'vuex'
import { useAlert } from 'dashboard/composables';

export default {
  name: 'BulkConfirmModal',
  props: {
    selectedInbox: { type: Object, required: true },
    messageIds: { type: Array, required: true },
    action: { type: String, required: true },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    actionLabel(){
      return this.action.charAt(0).toUpperCase() + this.action.slice(1)
    }
  },
  methods: {
    ...mapActions('whitelist', ['handleQuarantineAction']),
    async handleQuarantineDecision() {
      if (!this.selectedInbox.id) {
        useAlert('Please select an inbox first')
        return
      }
      this.isLoading = true

      try {
        await Promise.all(
          this.messageIds.map(async messageId => {
            await this.handleQuarantineAction({
              accountId: this.$route.params.accountId,
              inboxId: this.selectedInbox.id,
              messageId,
              action: this.action,
            })
          })
        )
        useAlert(`Messages ${this.action}d successfully!`)
        this.$emit('refresh')
        this.$emit('close')
      } catch (e) {
        console.error(e)
        useAlert(`Failed to ${this.action} messages`)
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/50 z-50"
  >
    <div class="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-lg w-96">
      <h2 class="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-4">
        Confirm Action
      </h2>
      <div class="mb-6">
        <p class="text-slate-600 dark:text-slate-300 mb-4">
          Are you sure you want to {{ action }} the selected questions? This action cannot be undone.
        </p>
      </div>

      <div class="flex justify-end gap-3">
        <woot-button
          variant="clear"
          color-scheme="secondary"
          @click="$emit('close')"
          :disabled="isLoading"
        >
          Cancel
        </woot-button>
        <woot-button
          variant="smooth"
          :color-scheme="action === 'approve' ? 'success' : 'alert'"
          @click="handleQuarantineDecision"
          :disabled="isLoading"
          :loading="isLoading"
        >
          {{ isLoading ? 'Loading...' : actionLabel }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
